import { Permission, Role } from "@bluefalcon/users-management-client-fetch";
import { Button, Card, CardBody, FormControl, FormLabel, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { iamService } from "../services";

type ManagePermissionsModalProps = {
    role: Role;
    isOpen: boolean;
    onClose: () => void;
    permissions: Permission[];
};

export const ManagePermissionsModal = ({
    role,
    isOpen,
    onClose,
    permissions,
}: ManagePermissionsModalProps) => {


    const filterPermissions = (permissions: Permission[]) => {
        return permissions.filter((perm) => !role.permissions.map((p) => p.id).includes(perm.id));
    };

    useEffect(() => {
        setFilteredPermissions(filterPermissions(permissions));
    }, [role]);

    const [selectedPermission, setSelectedPermission] = useState<Permission | undefined>(undefined);
    const [filteredPermissions, setFilteredPermissions] = useState<Permission[]>(filterPermissions(permissions));


    const handleGrant = async () => {
        if (selectedPermission) {
            await iamService.addPermissionToRole(selectedPermission.id, role.id);
        }
        onClose();
    };

    const onSelect = (permissionId: number) => {
        const perm = filteredPermissions.find((p) => p.id === permissionId);
        setSelectedPermission(perm);
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Grant Permission</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <FormControl>
                        <FormLabel htmlFor="permission">Select Permission</FormLabel>
                        <Select
                            id="permission"
                            placeholder="Select Permission"
                            onChange={(e) => onSelect(Number(e.target.value))}
                        >
                            {filteredPermissions.map((permission) => (
                                <option key={permission.id} value={permission.id}>
                                    {permission.name}
                                </option>
                            ))}
                        </Select>
                    </FormControl>
                    <Card mt={2}>
                        <CardBody>
                            {
                                role.permissions.length > 0 ?
                                    role.permissions.map((p) => (
                                        <Text>{p.name}</Text>
                                    )) :
                                    <Text>None</Text>
                            }
                        </CardBody>
                    </Card>
                </ModalBody>

                <ModalFooter>
                    <Button variant="ghost" onClick={onClose} mr={3}>Cancel</Button>
                    <Button colorScheme="primary" onClick={handleGrant}>Grant</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
};
